import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';

const CustomDatePicker = ({ value, onChange, placeholder, style }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(moment(value || new Date()));
  const [selectedDate, setSelectedDate] = useState(value ? moment(value) : null);
  const [viewMode, setViewMode] = useState('calendar'); // 'calendar', 'month', 'year'
  const calendarRef = useRef(null);

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDateClick = (date) => {
    setSelectedDate(date);
    onChange(date.format('YYYY-MM-DD'));
    setShowCalendar(false);
  };

  const handleMonthClick = (month) => {
    setCurrentMonth(currentMonth.clone().month(month));
    setViewMode('calendar');
  };

  const handleYearClick = (year) => {
    setCurrentMonth(currentMonth.clone().year(year));
    setViewMode('month');
  };

  
  const handlePrevMonth = () => {
    setCurrentMonth(currentMonth.clone().subtract(1, 'month'));
  };

  const handleNextMonth = () => {
    setCurrentMonth(currentMonth.clone().add(1, 'month'));
  };

  const handlePrevYear = () => {
    setCurrentMonth(currentMonth.clone().subtract(1, 'year'));
  };

  const handleNextYear = () => {
    setCurrentMonth(currentMonth.clone().add(1, 'year'));
  };

  const renderCalendar = () => {
    const startOfMonth = currentMonth.clone().startOf('month');
    const endOfMonth = currentMonth.clone().endOf('month');
    const startOfWeek = startOfMonth.clone().startOf('week');
    const endOfWeek = endOfMonth.clone().endOf('week');

    const days = [];
    const day = startOfWeek.clone();

    while (day.isSameOrBefore(endOfWeek)) {
      days.push(day.clone());
      day.add(1, 'day');
    }

    const weeks = [];
    let week = [];

    days.forEach((day, index) => {
      week.push(day);
      if ((index + 1) % 7 === 0 || index === days.length - 1) {
        weeks.push(week);
        week = [];
      }
    });

    return weeks;
  };

  const renderMonths = () => {
    const months = [];
    for (let i = 0; i < 12; i++) {
      months.push(moment().month(i));
    }
    return months;
  };

  const renderYears = () => {
    const years = [];
    const currentYear = moment().year();
    for (let i = currentYear - 10; i <= currentYear + 10; i++) {
      years.push(i);
    }
    return years;
  };

  const isToday = (day) => {
    return day.isSame(moment(), 'day');
  };

  const isSelected = (day) => {
    return selectedDate && day.isSame(selectedDate, 'day');
  };

  const isCurrentMonth = (day) => {
    return day.isSame(currentMonth, 'month');
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }} ref={calendarRef}>
      <input
        type="text"
        value={selectedDate ? selectedDate.format('DD-MM-YYYY') : ''}
        placeholder={placeholder}
        readOnly
        onClick={() => setShowCalendar(!showCalendar)}
        style={{
          ...style,
          cursor: 'pointer',
          backgroundColor: 'white'
        }}
      />

      {showCalendar && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: '0',
          zIndex: 1000,
          background: 'white',
          border: '2px solid #e2e8f0',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
          padding: '16px',
          minWidth: '320px',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          marginTop: '8px'
        }}>
          {/* Calendar Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px',
            padding: '0 8px'
          }}>
            <button
              onClick={viewMode === 'calendar' ? handlePrevMonth : viewMode === 'month' ? handlePrevYear : () => {}}
              style={{
                background: 'linear-gradient(135deg, #015c57 0%, #0a7d75 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                width: '32px',
                height: '32px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                fontWeight: 'bold',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(1, 92, 87, 0.3)'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'scale(1.1)';
                e.target.style.boxShadow = '0 4px 12px rgba(1, 92, 87, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 2px 8px rgba(1, 92, 87, 0.3)';
              }}
            >
              ‹
            </button>

            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1e293b',
              textTransform: 'capitalize',
              cursor: 'pointer'
            }}
            onClick={() => {
              if (viewMode === 'calendar') setViewMode('month');
              else if (viewMode === 'month') setViewMode('year');
            }}
            onMouseOver={(e) => {
              e.target.style.color = '#015c57';
              e.target.style.textDecoration = 'underline';
            }}
            onMouseOut={(e) => {
              e.target.style.color = '#1e293b';
              e.target.style.textDecoration = 'none';
            }}
            >
              {viewMode === 'calendar' && currentMonth.format('MMMM YYYY')}
              {viewMode === 'month' && currentMonth.format('YYYY')}
              {viewMode === 'year' && 'Select Year'}
            </div>

            <button
              onClick={viewMode === 'calendar' ? handleNextMonth : viewMode === 'month' ? handleNextYear : () => {}}
              style={{
                background: 'linear-gradient(135deg, #015c57 0%, #0a7d75 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                width: '32px',
                height: '32px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                fontWeight: 'bold',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(1, 92, 87, 0.3)'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'scale(1.1)';
                e.target.style.boxShadow = '0 4px 12px rgba(1, 92, 87, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 2px 8px rgba(1, 92, 87, 0.3)';
              }}
            >
              ›
            </button>
          </div>

          {/* Calendar View */}
          {viewMode === 'calendar' && (
            <>
              {/* Week Days Header */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                gap: '4px',
                marginBottom: '8px'
              }}>
                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                  <div key={day} style={{
                    textAlign: 'center',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#64748b',
                    padding: '8px 4px'
                  }}>
                    {day}
                  </div>
                ))}
              </div>

              {/* Calendar Days */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                gap: '4px'
              }}>
                {renderCalendar().map((week, weekIndex) => (
                  week.map((day, dayIndex) => (
                    <button
                      key={`${weekIndex}-${dayIndex}`}
                      onClick={() => handleDateClick(day)}
                      style={{
                        padding: '8px',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'all 0.2s ease',
                        background: isSelected(day) 
                          ? 'linear-gradient(135deg, #015c57 0%, #0a7d75 100%)'
                          : isToday(day)
                          ? '#f0f9ff'
                          : 'transparent',
                        color: isSelected(day)
                          ? 'white'
                          : isToday(day)
                          ? '#0284c7'
                          : isCurrentMonth(day)
                          ? '#1e293b'
                          : '#94a3b8',
                        boxShadow: isSelected(day) ? '0 4px 12px rgba(1, 92, 87, 0.3)' : 'none',
                        transform: isSelected(day) ? 'scale(1.05)' : 'scale(1)'
                      }}
                      onMouseOver={(e) => {
                        if (!isSelected(day)) {
                          e.target.style.background = '#f8fafc';
                          e.target.style.transform = 'scale(1.05)';
                        }
                      }}
                      onMouseOut={(e) => {
                        if (!isSelected(day)) {
                          e.target.style.background = isToday(day) ? '#f0f9ff' : 'transparent';
                          e.target.style.transform = 'scale(1)';
                        }
                      }}
                    >
                      {day.format('D')}
                    </button>
                  ))
                ))}
              </div>
            </>
          )}

          {/* Month View */}
          {viewMode === 'month' && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '8px'
            }}>
              {renderMonths().map((month, index) => (
                <button
                  key={index}
                  onClick={() => handleMonthClick(index)}
                  style={{
                    padding: '12px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.2s ease',
                    background: month.isSame(currentMonth, 'month')
                      ? 'linear-gradient(135deg, #015c57 0%, #0a7d75 100%)'
                      : '#f8fafc',
                    color: month.isSame(currentMonth, 'month')
                      ? 'white'
                      : '#1e293b',
                    boxShadow: month.isSame(currentMonth, 'month') ? '0 4px 12px rgba(1, 92, 87, 0.3)' : 'none',
                    transform: month.isSame(currentMonth, 'month') ? 'scale(1.05)' : 'scale(1)'
                  }}
                  onMouseOver={(e) => {
                    if (!month.isSame(currentMonth, 'month')) {
                      e.target.style.background = '#e2e8f0';
                      e.target.style.transform = 'scale(1.05)';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!month.isSame(currentMonth, 'month')) {
                      e.target.style.background = '#f8fafc';
                      e.target.style.transform = 'scale(1)';
                    }
                  }}
                >
                  {month.format('MMM')}
                </button>
              ))}
            </div>
          )}

          {/* Year View */}
          {viewMode === 'year' && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '8px',
              maxHeight: '200px',
              overflowY: 'auto'
            }}>
              {renderYears().map(year => (
                <button
                  key={year}
                  onClick={() => handleYearClick(year)}
                  style={{
                    padding: '8px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.2s ease',
                    background: year === currentMonth.year()
                      ? 'linear-gradient(135deg, #015c57 0%, #0a7d75 100%)'
                      : '#f8fafc',
                    color: year === currentMonth.year()
                      ? 'white'
                      : '#1e293b',
                    boxShadow: year === currentMonth.year() ? '0 4px 12px rgba(1, 92, 87, 0.3)' : 'none',
                    transform: year === currentMonth.year() ? 'scale(1.05)' : 'scale(1)'
                  }}
                  onMouseOver={(e) => {
                    if (year !== currentMonth.year()) {
                      e.target.style.background = '#e2e8f0';
                      e.target.style.transform = 'scale(1.05)';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (year !== currentMonth.year()) {
                      e.target.style.background = '#f8fafc';
                      e.target.style.transform = 'scale(1)';
                    }
                  }}
                >
                  {year}
                </button>
              ))}
            </div>
          )}

          {/* Footer */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '16px',
            paddingTop: '16px',
            borderTop: '1px solid #e2e8f0'
          }}>
            <button
              onClick={() => {
                setSelectedDate(moment());
                onChange(moment().format('YYYY-MM-DD'));
                setShowCalendar(false);
              }}
              style={{
                padding: '6px 12px',
                background: '#f1f5f9',
                color: '#64748b',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                fontSize: '12px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#e2e8f0';
                e.target.style.color = '#475569';
              }}
              onMouseOut={(e) => {
                e.target.style.background = '#f1f5f9';
                e.target.style.color = '#64748b';
              }}
            >
              Today
            </button>

            <button
              onClick={() => setShowCalendar(false)}
              style={{
                padding: '6px 12px',
                background: '#f8fafc',
                color: '#64748b',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                fontSize: '12px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#f1f5f9';
                e.target.style.color = '#475569';
              }}
              onMouseOut={(e) => {
                e.target.style.background = '#f8fafc';
                e.target.style.color = '#64748b';
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDatePicker;
